import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ColumnDefinition } from 'src/app/dto/columnDefinition';
import { DealerEmployee } from 'src/app/models/dealer-employee.model';
import { Dealer } from 'src/app/models/dealer.model';
import { User } from 'src/app/models/user.model';
import { DealersService } from 'src/app/services/dealers.service';
import { UserService } from 'src/app/services/user.service';
import { plaintext } from '../../../assets/plaintext';
import { SelectGroupDialogComponent } from '../select-group-dialog/select-group-dialog.component';

@Component({
  selector: 'app-view-reports-as-dialog',
  templateUrl: './view-reports-as-dialog.component.html',
  styleUrls: ['./view-reports-as-dialog.component.scss']
})
export class ViewReportsAsDialogComponent implements OnInit {
  currentStep;

  isDealersLoading = false;
  dealers: Dealer[];
  currentOffset = 0;
  currentTake = 15;
  searchValue = '';
  userType = '';
  language = '';
  isPSC = false;

  user: User;
  plaintext = plaintext;

  selectedZoneFilter : string;
  selectedDisctrictFilter : string;
  selectedRegionFilter : string;

  employees: DealerEmployee[];
  baseEmployees: DealerEmployee[];

  constructor(public dialogRef: MatDialogRef<SelectGroupDialogComponent>, private dealersService: DealersService, private router: Router, private userService: UserService) {
    this.userType = this.userService.user.businessFunction;
    this.language = this.userService.user.language;
  }

  ngOnInit(): void {
    console.log(this.language);

    this.employeeColumns = [
      {
        columnDef: 'name',
        header: plaintext.table.name[this.language],
        cell: (w: any) => `${w.name}`
      },
      { columnDef: 'gmid', header: 'ID', cell: (w: any) => `${w.gmid}` },
      { columnDef: 'gmvssmbusinessroledn', header: plaintext.table.roles[this.language], cell: (w: any) => `${w.gmvssmbusinessroledn}` }
    ];

    this.employeeSearchText = plaintext.table.search[this.language];

    if (this.userType === 'dealeradmin') {
      this.width = '1200px';
      this.height = '630px';
      this.employeeColumns.push({ columnDef: 'gmvssmadminroledn', header: 'Admin Role', cell: (w: any) => `${w.gmvssmadminroledn}` });
      document.documentElement.style.setProperty('--width', this.width);
      document.documentElement.style.setProperty('--height', this.height);
      this.currentStep = 1;
      this.isDealersLoading = true;
      this.dealersService.search(this.currentOffset, this.currentTake, this.searchValue).subscribe(dealers => {
        this.dealers = dealers;
        this.isDealersLoading = false;
      });
    } else if (this.userService.user.isPSC) {
      this.width = '1000px';
      this.height = '500px';
      document.documentElement.style.setProperty('--width', this.width);
      document.documentElement.style.setProperty('--height', this.height);
      this.isPSC = true;
      this.viewAsEmployee = true;
      this.isDealersLoading = true;
      this.currentStep = 2;
      this.dealersService.getEmployeesForDealership().subscribe(employees => {
        this.employees = employees.filter(e => e.gmid != this.userService.user.gmid);
        this.baseEmployees = employees;
        this.isDealersLoading = false;
      })
    }
  }

  employeeSelection: SelectionModel<DealerEmployee> = new SelectionModel(false);
  employeeSearchInput: string = '';
  selection: SelectionModel<Dealer> = new SelectionModel(false);

  employeeColumns: ColumnDefinition[];

  viewAsPSC: boolean = true;
  viewAsEmployee: boolean = false;

  setViewAsPSC() {
    this.viewAsPSC = !this.viewAsPSC;
    this.viewAsEmployee = !this.viewAsEmployee;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  next() {
    this.currentStep = 2;
    this.isDealersLoading = true;
    this.dealersService.getEmployeesForDealership(this.selection.selected[0].vendorId).subscribe(employees => {
      this.employees = employees;
      this.baseEmployees = employees;
      this.isDealersLoading = false;
    })
  }

  back() {
    console.log('filters', this.selectedDisctrictFilter, this.selectedRegionFilter, this.selectedZoneFilter)
    this.currentStep = 1;
  }

  go() {
    if (this.isPSC) {
      this.router.navigate(['/reports/viewas', this.userService.user.bac, this.employeeSelection.selected[0].gmid],
        { queryParams: { user: this.employeeSelection.selected[0].name, dealer: +this.userService.user.bac, role: this.employeeSelection.selected[0].gmvssmadminroledn } })
    } else {
      if (this.viewAsPSC) {
        this.router.navigate(['/reports/viewas', this.selection.selected[0].vendorId], { queryParams: { dealer: this.selection.selected[0].name } });
      } else {
        this.router.navigate(['/reports/viewas', this.selection.selected[0].vendorId, this.employeeSelection.selected[0].gmid],
          { queryParams: { user: this.employeeSelection.selected[0].name, dealer: this.selection.selected[0].name, role: this.employeeSelection.selected[0].gmvssmadminroledn } });
      }
    }
    this.dialogRef.close();
  }

  height;
  width;

  employeeSearchText;

  searchGroups() {
    this.isDealersLoading = true;
    this.dealersService.search(this.currentOffset, this.currentTake, this.searchValue).subscribe(dealers => {
      dealers.forEach(dealer => {
        this.selection.selected.forEach(selected => {
          if (dealer.guid == selected.guid) {
            this.selection.select(dealer);
            this.selection.deselect(selected);
          }
        })
      })
      this.dealers = dealers;
      this.isDealersLoading = false;
    })
  }

  searchEmployees(query) {
    const filterBy = query.toLowerCase();
    this.employees = this.baseEmployees.filter(e => e.name.toLowerCase().indexOf(filterBy) != -1 || 
      e.gmvssmbusinessroledn.toLowerCase().includes(filterBy) || 
      e.gmid.toString().toLowerCase().includes(filterBy) ||
      e.gmid.toString().toLowerCase().includes(filterBy) ||
      e.gmvssmadminroledn.toLowerCase().includes(filterBy))
  }

  refreshEmpoloyees() {
    this.isDealersLoading = true;
    if (this.userService.user.isPSC) {
      this.dealersService.getEmployeesForDealership(null, true).subscribe(employees => {
        this.employees = employees.filter(e => e.gmid != this.userService.user.gmid);
        this.baseEmployees = employees;
        this.isDealersLoading = false;
      })
    } else {
      this.dealersService.getEmployeesForDealership(this.selection.selected[0].vendorId, true).subscribe(employees => {
        this.employees = employees;
        this.baseEmployees = employees;
        this.isDealersLoading = false;
        console.log('setting loading to false')
      })
    }
  }
}
